import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TermsOfUse.css"; // Assuming you have a CSS file for styling
import files from "../../../assets/img/privacy_policy/files.svg";
import codicon_graph_line from "../../../assets/img/privacy_policy/codicon_graph_line.svg";
import proicons_cookies from "../../../assets/img/privacy_policy/proicons_cookies.svg";
import material_symbols from "../../../assets/img/privacy_policy/material_symbols.svg";
import light_globe from "../../../assets/img/privacy_policy/light_globe.svg";
import ion_call_outline from "../../../assets/img/privacy_policy/ion_call-outline.svg";
import iconoir_privacy_policy from "../../../assets/img/privacy_policy/iconoir_privacy_policy.svg";

const sections = [
  {
    id: "collected-info",
    title: "Terms of Use",
    img: files,
    description: (
      <>
        <p style={{ margin: "1em  0" }}>
          Your use of this website is expressly conditioned on your acceptance
          of these Terms of Use. If you do not agree with any section of the
          Terms of Use, you should not use this website
        </p>
        <p style={{ margin: "1em  0" }}>
          United Automobile Insurance Company reserves the right to update these
          Terms of Use at any time. Continued use of this site by you will
          constitute your acceptance of any changes to the Terms of Use. Please
          check this page often.
        </p>
        <p style={{ margin: "1em  0" }}>
          {" "}
          <b>Text Messaging Terms of use:</b> By providing your phone number you
          agree to receive customer care, billing or claims related text
          messages from <b>UAIC</b>. Message and data rates may apply. Message
          frequency varies. For help, you may call{" "}
          <a href="tel:3059405022">(305)-940-5022</a> for support. You can opt
          out at any time by replying <b>STOP.</b>
        </p>
        <h3> Passwords</h3>
        <p style={{ margin: "1em  0" }}>
          Some UAIC sites are restricted and require a user ID and a password
          for access. Unauthorized use of or access of such sites is prohibited.
        </p>
        <p style={{ margin: "1em  0" }}>
          By accessing UAIC sites requiring a User ID and password, you agree
          that:
        </p>
        <div style={{ paddingLeft: "3em" }}>
          <ul
            style={{ listStyleType: "disc", paaddingLeft: "10px" }}
            className="terms-of-use"
          >
            <li>
              UAIC is entitled to act on instructions received under your User
              ID and password.
            </li>
            <br />
            <li>
              UAIC is not liable for any unauthorized access to your personal
              information that is not the direct result of gross negligence or
              intentional misconduct on the part of UAIC.
            </li>
            <br />
            <li>
              You will keep your password confidential and you will notify UAIC
              immediately if you believe someone else has obtained your User ID
              and password or any unauthorized access to the online service site
              has occurred or may occur.
            </li>
            <br />
            <li>
              UAIC may block access to the online service site without prior
              notice if we believe your User ID and password are being used by
              someone other than you, if any unauthorized access to your
              personal information has occurred or may occur, or for other
              reasons.
            </li>
          </ul>
        </div>
      </>
    ),
  },
];

const PrivacyPolicy = () => {
  const [activeId, setActiveId] = useState("collected-info");

  const scrollToSection = (id) => {
    setActiveId(id);
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}

        {/* Main Content */}
        <div
          className="col-md-12 py-4"
          style={{ margin: "0 auto", width: "90%", maxWidth: "1000px" }}
        >
          {sections.map((section) => (
            <>
              <section id={section.id} key={section.id} className="mb-3 mt-3">
                <div className="d-flex">
                  <img
                    src={section.img}
                    alt="PC Icon"
                    className="me-2"
                    style={{ width: "35px", height: "35px" }}
                  />
                  <h3 className="fw-semibold">{section.title}</h3>
                </div>
                {/* <div
                  className="text-muted mt-2"
                  dangerouslySetInnerHTML={{ __html: section.description }}
                ></div> */}
                <div className=" mt-2">{section.description}</div>
              </section>
              <hr />
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
